import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ReadonlyInsuredAmount } from './read-only-insured-amount';
import { USD } from '../../constants/currency-codes';
import { InsuranceProviders } from '../../enums/insurance-providers';
import Global from '../../store/global-selectors';
import { useFulfillmentPlannerContext } from '../context';

import InsuranceOption from './index';

const FulfillmentPlannerInsuredAmount = ({
  currencySymbolClassName = null,
  className = null,
  disabled = false,
  fulfillmentPlanId = '',
  rowClassName,
}) => {
  const { calculateRecommendedInsuranceValue, insuranceProvider, packages, onInsuredAmountChange } = useFulfillmentPlannerContext();
  const sellerCurrencyCode = useSelector(Global.selectSellerDefaultCurrency) || USD;
  const isMultiPackage = packages.length > 1;
  const insuranceCurrencyCode = packages[0]?.insuredValue?.code || sellerCurrencyCode;

  const totalInsuredAmount = useMemo(
    () =>
      packages.reduce((sum, p) => {
        return sum + (p?.insuredValue?.value ?? 0);
      }, 0),
    [packages],
  );

  const currencyCode = useMemo(
    () => (insuranceProvider.name === InsuranceProviders.Shipsurance.name ? USD : insuranceCurrencyCode),
    [insuranceProvider.name, insuranceCurrencyCode],
  );

  const updatedProps = {
    currencySymbolClassName,
    className,
    fulfillmentPlanId,
    disabled: disabled || isMultiPackage,
    insuredAmount: {
      value: totalInsuredAmount || calculateRecommendedInsuranceValue(),
      code: currencyCode,
    },
    onChange: onInsuredAmountChange,
    rowClassName,
    selectedInsuranceOptionId: insuranceProvider.insuranceProviderId,
  };
  if (updatedProps.disabled) {
    return <ReadonlyInsuredAmount {...updatedProps} />;
  }
  return <InsuranceOption {...updatedProps} />;
};

export default FulfillmentPlannerInsuredAmount;

FulfillmentPlannerInsuredAmount.propTypes = {
  currencySymbolClassName: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string,
  rowClassName: PropTypes.string,
};
